define('views/components/recurring_customer_product_compact/recurring_product',['require','backbone','models/basket_product','text!templates/components/recurring_customer_product_compact/recurring_product.html'],function (require) {
  var Backbone = require("backbone");

  var BasketProductModel = require("models/basket_product");

  var temp = require("text!templates/components/recurring_customer_product_compact/recurring_product.html");

  return Backbone.Marionette.ItemView.extend({
    tagName: "tr",
    template: _.template(temp),
    className: "recurring-product-item",

    initialize: function () {
      // Add expired class if license expired
      if (
        this.model.get("end_time") &&
        new Date(this.model.get("end_time")) < new Date()
      ) {
        this.$el.addClass("expired");
      }
      // Show only date
      this.model.set(
        "end_date",
        this.model.get("end_time") &&
          new Date(this.model.get("end_time")).toLocaleDateString()
      );
      this.model.set(
        "start_date",
        new Date(this.model.get("start_time")).toLocaleDateString()
      );
    },

    ui: function () {
      return {
        cancelButton: "#cancel-button",
        activateButton: "#activate-button",
      };
    },

    events: {
      "click @ui.cancelButton": "cancelButtonClicked",
      "click @ui.activateButton": "activateButtonClicked",
    },

    cancelButtonClicked: function () {
      var _this = this;
      App.utils.showConfirmModal(
        App.polyglot.t("cancel_subscription_confirm_message"),
        function () {
          _this._cancel();
        }
      );
    },

    _cancel: function () {
      var _this = this;

      this.ui.cancelButton.addClass("loading");

      $.ajax({
        url:
          App.Config.apiBase +
          "recurring-licenses/" +
          this.model.get("id") +
          "/cancel/",
        method: "post",
        success: function (response) {
          
          _this.model.set("is_activated", false);

          _this.render();

          App.utils.showMessage("success", App.polyglot.t("cancel_success"));

          _this.ui.cancelButton.removeClass("loading");
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // Show error messages
          if (xhr.responseJSON.errors) {
            for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
              App.utils.showMessage(
                "error",
                xhr.responseJSON.errors[i].message
              );
            }
          }

          _this.ui.cancelButton.removeClass("loading");
        },
      });
    },

    activateButtonClicked: function () {
      // Add product to basket

      var _this = this;

      var is_exist = App.context.basket
        .get("products")
        .find(function (basketProduct) {
          return basketProduct.license === _this.model.get("id");
        });

      if (is_exist) {
        // Already in basket
        App.utils.showMessage("warning", App.polyglot.t("already_in_basket"));
      } else {
        this.ui.activateButton.addClass("loading");

        var product = this.model.get("product");

        $.ajax({
          url:
            App.Config.apiBase + "products/" + product.id + "/purchase_info/",
          method: "get",
          success: function (response) {
            
            _this._addToBasket(response);

            _this.ui.activateButton.removeClass("loading");
          },
          error: function (xhr, ajaxOptions, thrownError) {
            // Show error messages
            if (xhr.responseJSON.errors) {
              for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                App.utils.showMessage(
                  "error",
                  xhr.responseJSON.errors[i].message
                );
              }
            }

            _this.ui.activateButton.removeClass("loading");
          },
        });
      }
    },

    _addToBasket: function (product) {
      // Add product to basket, if not exists
      var basketProduct = new BasketProductModel({
        product: product,
        count: 1,
        license: this.model.get("id"),
      });
      App.context.basket.get("products").push(basketProduct.attributes);

      App.vent.trigger("basket-updated");

      // Show success message
      App.utils.showMessage("success", App.polyglot.t("add_to_basket_success"));
    },
  });
});

